'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _tslib = require('../_virtual/_tslib.js');
var linkedListUtils = require('./linked-list-utils.js');

const updateLinkedList = (item, config) => {
    const { list, factory } = config;
    linkedListUtils.assertPresence(item.id, list.items);
    /**
     * This method should not update any ids, this is why they are removed from the item.
     */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const updatedProperties = _tslib.__rest(item, ["nextId", "previousId", "id"]);
    const currentItem = list.items[item.id];
    const newItems = Object.assign(Object.assign({}, list.items), { [item.id]: Object.assign({ nextId: currentItem.nextId, previousId: currentItem.previousId, id: currentItem.id }, updatedProperties) });
    return factory({
        headId: list.headId,
        items: newItems,
    });
};

exports.updateLinkedList = updateLinkedList;
//# sourceMappingURL=update-linked-list.js.map
